import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: var(--spacing-5);
    gap: var(--spacing-1);
`;

export const CardsWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--spacing-2);
    margin-top: var(--spacing-6);
    @media screen and (min-width: ${breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        gap: var(--spacing-3);
    }
`;

export const InputLabel = styled.div<{ shown?: boolean }>`
    opacity: 0;
    ${({ shown }) =>
        shown &&
        css`
            opacity: 1;
        `};
`;

export const TransportationTypeCard = styled.div<{ isActive?: boolean }>`
    position: relative;
    padding: var(--spacing-2);
    border: 1px solid var(--color-grey-6);
    box-shadow: 0 0 0 1px var(--color-primary-white);
    transition:
        box-shadow 0.3s,
        border-color 0.3s;
    cursor: pointer;
    ${({ isActive }) =>
        isActive &&
        css`
            border-color: var(--color-primary-black);
            box-shadow: 0 0 0 1px var(--color-primary-black);
        `};
`;

export const TransportationTypeCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-1);
    margin-bottom: var(--spacing-3);
`;

export const PriceWrapper = styled.div`
    margin-top: var(--spacing-3);
`;
